/**
 * Use this mixin for messaging.
 */
export const messaging = {
  methods: {
    /**
     * Loops through array of objects and returns
     * element when name matches.
     * @param arr array
     * @param name string
     * @return object
     */
    message: function (arr, name) {
      var obj = {};
      arr.forEach((item) => {
        if (item.name == name) {
          obj = item;
        }
      });
      return obj;
    },
  },
};
